<!-- Модальная оболочка создания расхода: показывает форму и footer-действия. -->
<template>
  <base-modal
    :visible="true"
    title="Создание нового расхода"
    size="xl"
    footer-align="start"
    elevated-footer
    @close="$emit('close')"
  >
    <ExpenseForm
      :form-id="formId"
      :trip-id="tripId"
      @close="$emit('close')"
      @expense-created="$emit('expense-created')"
      @submitting-change="isSubmitting = $event"
    />

    <template #footer>
      <base-primary-button
        type="submit"
        :form="formId"
        :disabled="isSubmitting"
        class="form-btn"
      >
        <span v-if="isSubmitting">Сохранение...</span>
        <span v-else>Сохранить</span>
      </base-primary-button>
      <base-button
        type="button"
        @click="$emit('close')"
        class="form-btn"
        :disabled="isSubmitting"
      >
        Отмена
      </base-button>
    </template>
  </base-modal>
</template>

<script>
import ExpenseForm from "@/components/Expense/ExpenseForm.vue";

export default {
  name: "AddExpensesModal",

  components: {
    ExpenseForm,
  },

  props: {
    tripId: {
      type: Number,
      default: null,
    },
  },

  emits: ["close", "expense-created"],

  data() {
    return {
      formId: "add-expense-form",
      isSubmitting: false,
    };
  },
};
</script>
